/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let variantId
const productSwatches = document.querySelectorAll('.ProductItem__Swatch__Radio');
const productShadesForm = document.querySelectorAll('.ProductForm__AddToCart--select-shade');
const productSwatchesDisabled = document.querySelectorAll('.ProductItem__Swatch__Radio--disabled');

productSwatchesDisabled.forEach(elem => {
  elem.addEventListener('change', e => {
    const productItem = e.target.closest('.ProductItem');
    setTimeout(() => {
      productItem.querySelector('.ProductForm__AddToCart-text').innerHTML = "out of stock";
      productItem.querySelector('.ProductForm__AddToCart').setAttribute('disabled', 'disabled');
      window.dispatchEvent(new Event('resize'));
    }, 100);
  })
})

productShadesForm.forEach(elem => {
  elem.addEventListener('click', e => {
    const productItem = e.target.closest('.ProductItem');
    productItem.querySelectorAll('.ProductItem__swatches-holder').forEach(elem => {
      elem.style.height = '100%';
      elem.style.overflow = 'visible';
      elem.style.opacity = '100%';
    })
    window.dispatchEvent(new Event('resize'));
    setTimeout(() => {
      productItem.querySelector('.ProductForm__AddToCart').setAttribute('type', 'submit');
      productItem.querySelector('.ProductForm__AddToCart-text').innerHTML = "Add to bag";
      productItem.querySelector('.ProductItem__Price').innerHTML = productItem.querySelector('[data-variant-price]:checked').getAttribute('data-variant-price');
    }, 100);
  })
})

productSwatches.forEach(elem => {
  const productItem = elem.closest('.ProductItem')
  if(elem.hasAttribute('checked') && productItem.querySelector('.ProductItem__Color-swatches-value')) {
    productItem.querySelector('.ProductItem__Color-swatches-value').innerHTML = elem.getAttribute('value')
  }

  elem.addEventListener('change', e => {
    const productItem = e.target.closest('.ProductItem')
    productItem.querySelector('input[name="id"]').setAttribute('value', e.target.getAttribute('data-variant-id'))
    if(productItem.querySelector('.ProductItem__Color-swatches-value')) {
      productItem.querySelector('.ProductItem__Color-swatches-value').innerHTML = e.target.getAttribute('value')
    }
    productItem.querySelector('.ProductForm__AddToCart-text').innerHTML = "Add to bag";
    productItem.querySelector('.ProductForm__AddToCart').removeAttribute('disabled');
    productItem.querySelector('.ProductItem__Price').innerHTML = e.target.getAttribute('data-variant-price');
    window.dispatchEvent(new Event('resize'));
  })
})

document.querySelectorAll('.collection-cart-btn').forEach(elem => {
  elem.addEventListener('submit', function(e) {
    e.preventDefault()
    const pageOverlay = document.querySelector('.PageOverlay');
    const cartDrawerClose = document.querySelector('#sidebar-cart .Drawer__Close')
    const cartDrawer = document.querySelector('#sidebar-cart');
    variantId = e.target.querySelector('input[name="id"]').getAttribute('value');

    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(() => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      pageOverlay.classList.add('is-visible');
      cartDrawer.setAttribute('aria-hidden', false);
      pageOverlay.addEventListener('click', () => {
        pageOverlay.classList.remove('is-visible');
        cartDrawer.setAttribute('aria-hidden', true);
      })
      cartDrawerClose.addEventListener('click', () => {
        pageOverlay.classList.remove('is-visible');
        cartDrawer.setAttribute('aria-hidden', true);
      })
    })
  })
})